import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import axios from "axios";
import jwt from "jsonwebtoken";
import {Notification} from "element-ui";

import renewal from "./modules/renewal";
import auth from "./modules/auth";
import eventRegistration from "./modules/event-registration";
import getUrlParams from "./helper";

Vue.use(Vuex);

const CONFIG_NAME = "dynamic-sec"; //'donation-fec' 'donation-p2-branch' 'donation-public'
// const DOMAIN_API_DEV = "https://dev13.3degreesnorth.com.au"; //'https://p2stage.nswliberal.org.au' 'https://k13test2.nswliberal.org.au'
// const DOMAIN_API_DEV = "https://xperience.3degreesnorth.com.au"; //'https://p2stage.nswliberal.org.au' 'https://k13test2.nswliberal.org.au'
//const DOMAIN_API_DEV = window.location.origin; //'https://p2stage.nswliberal.org.au' 'https://k13test2.nswliberal.org.au'
const DOMAIN_API_DEV = /localhost/.test(window.location.origin) ? 'https://xperience.3degreesnorth.com.au' : ''; //'https://p2stage.nswliberal.org.au' 'https://k13test2.nswliberal.org.au'
const ENTRY_POINT = process.env.NODE_ENV !== "production" ? DOMAIN_API_DEV : "";

if (process.env.NODE_ENV !== "production" || !window["donation-form"]) {
  //TODO - should not assume page always has a donation form.
  window["donation-form"] = {
    title: "test config",
    configurationSet: CONFIG_NAME,
  };
}

// TODO: Modularize vuex store

export default new Vuex.Store({
  state: {
    editState: false,
    configurationSet: window["donation-form"]["configurationSet"],
    steps: 1,
    configSettings: {},
    queryType: "",
    donorInformation: {
      "allow-monthly-donation": false,
      gift_array: null,
      first_name: null,
      last_name: null,
      receipt: {},
      "donor-type": "individual",
      "payment-type": "credit-card",
      role: [],
      address: {},
      "token-cookies": false,
    },
    bpayReceipt: {},
    // https://dev13.3degreesnorth.com.au - dev hosturl
    baseURL: `${ENTRY_POINT}/api/`,
    URL: `${ENTRY_POINT}`,
  },
  mutations: {
    updateQueryType(state, type) {
      state.queryType = type;
    },
    updateDonorRole(state, payload) {
      // cast to array as API returns string in some cases
      // TODO: fix API to return array?
      state.donorInformation.role = typeof payload === "string" ? [payload] : payload;
    },
    toggleEdit(state, payload) {
      state.editState = payload;
    },
    updateConfigSettings(state, data) {
      state.configSettings = data;
    },
    updateDonorInformation(state, object) {
      state.donorInformation[object.property] = object.content;
    },
    updateUserInfo(state, name) {
      state.donorInformation["prefix"] = name.prefix;
      state.donorInformation["first_name"] = name.first_name;
      state.donorInformation["last_name"] = name.last_name;
      state.donorInformation["dob"] = name.dob;
      state.donorInformation["email"] = name.email;
      state.donorInformation["mobile"] = name.mobile;
    },
    updateCorporateInfo(state, info) {
      state.donorInformation["corporate-info"] = info;
    },
    updateUserAddress(state, addressObj) {
      state.donorInformation["address"] = addressObj;
    },
    updateUserName(state, name) {
      state.donorInformation["first_name"] = name["first_name"];
      state.donorInformation["last_name"] = name["last_name"];
    },
    updateDonorType(state, type) {
      state.donorInformation["donor-type"] = type;
    },
    updatePaymentType(state, type) {
      state.donorInformation["payment-type"] = type;
    },
    updateReceipt(state, receipt) {
      state.donorInformation["receipt"] = receipt;
    },
    updateDonationFrequency(state, frequency) {
      state.donorInformation["allow-monthly-donation"] = frequency;
    },
    updateDonationAmount(state, amount) {
      state.donorInformation["donation-amount"] = amount;
    },
    updateTokenCookies(state, payload) {
      state.donorInformation["token-cookies"] = payload;
    },
    toStep(state, step) {
      state.steps = step;
    },
    NEXT(state) {
      state.steps++;
    },
    BACK(state) {
      if (state.steps !== 1) {
        return state.steps--;
      }
      return false;
    },
  },
  actions: {
    setDonorRole({commit}, payload) {
      //var decoded = jwt.decode(token, {complete: true});
      let token;
      commit("updateTokenCookies", false);

      if (getUrlParams().token) {
        token = getUrlParams().token;
      } else if (payload.token_cookie) {
        token = payload.token_cookie;
        commit("updateTokenCookies", true);
      }

      if (token) {
        const options = {complete: true};
        const decoded = jwt.decode(token, options);
        commit("updateDonorRole", decoded.payload.Role);
      }
    },
    async setConfigSettings({commit, state, rootState}) {

      axios.defaults.baseURL = state.baseURL;

      // get parsed UrlParams from state
      const parsedUrlParams = rootState.auth.parsedUrlParams


      // get config settings, if 'key' is passed as a urlParam add it to the request URL
      try {
        const keyParam = parsedUrlParams.key ? `?key=${parsedUrlParams.key}` : ''

        const configResponse = await axios({
          method: 'get',
          url: `config/${state.configurationSet}${keyParam}`
        })

        if (configResponse.status !== 200 || !configResponse?.data[state.configurationSet]) {
          Notification.error({message: 'Failed to load form configuration data'})
        }

        // save config in state
        commit('updateConfigSettings', configResponse.data[state.configurationSet])

      } catch (error) {
        Notification.error({message: 'Failed to load form data'})
      }


      // event user might have already been set by initiateAuthAndSetEventUser

      // local scope event user
      let eventUser = rootState.auth.eventUser

      // if eventUser not already set, try to set via donation-management/ask/oneclick
      // example url: https://dev13.3degreesnorth.com.au/donation?SEQN=14359568&CK=9B5B54E7-AEAC-481C-ACC4-04AE0B958AB1
      // api endpoint -- POST / https://dev13.3degreesnorth.com.au/api/donation-management/ask/14359568/oneclick
      if (!eventUser) {

        try {
          const seqn = parsedUrlParams.seqn,
              ck = parsedUrlParams.ck

          if (seqn && ck) {

            const requestPayload = {one_click_token: ck}
            const askResponse = await axios({
              method: "post",
              url: `donation-management/ask/${seqn}/oneclick`,
              data: requestPayload,
            })

            if (askResponse.status !== 200) {
              Notification.error({message: 'Failed to find user information'})
            }

            eventUser = askResponse.data || null
          }

        } catch (error) {
          Notification.error({message: 'Failed to find user information'})
        }
      }

      // if eventUser has been set by either process
      if (eventUser) {
        for (const [property, value] of Object.entries(eventUser)) {
          commit("updateDonorInformation", {
            property,
            content: value,
          });
        }

        // dob not set by api (add as separate call so as not to mutate eventUser in auth state)
        commit("updateDonorInformation", {
          property: 'dob',
          content: '',
        })
      }

    },


    async validateElectoralAddress({state}, payload) {
      axios.defaults.baseURL = state.baseURL;

      try {
        const res = await axios({
          method: "post",
          url: "donation-management/validate-electoral-roll",
          data: payload,
        });

        return res.data.validation_result;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    async suppressAddress({state}, payload) {
      axios.defaults.baseURL = state.baseURL;

      try {
        const res = await axios({
          method: "post",
          url: "donation-management/check-electoral-roll-suppressed",
          data: payload,
        });

        return {isSuppressed: res.data.AddressIsSuppressed};
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    next({commit}) {
      commit("NEXT");
    },
  },
  getters: {
    donorIsStaff: (state) => {
      const staffRole = state.donorInformation["token-cookies"]
          ? ["CHQStaff", "LPANSWStaff"]
          : ["AdminPortal", "CHQStaff", "OCERAccess"];
      const roleValidation = (role) => staffRole.includes(role);
      return state.donorInformation.role.some(roleValidation);
    },
  },
  modules: {auth, renewal, eventRegistration},

  // console logs vuex state management
  plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : [],
});
